import { render, staticRenderFns } from "./EditContactoCliente.vue?vue&type=template&id=85cfae12&scoped=true"
import script from "./EditContactoCliente.vue?vue&type=script&lang=js"
export * from "./EditContactoCliente.vue?vue&type=script&lang=js"
import style0 from "./EditContactoCliente.vue?vue&type=style&index=0&id=85cfae12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cfae12",
  null
  
)

export default component.exports